<template>
  <aside class="we-left-panel">
    <el-card shadow="never" class="we-type-card">
      <div slot="header" class="we-card-title">
        <i class="el-icon-s-grid"></i>
        <span>选择题型</span>
      </div>
      <div v-for="group in typeGroups" :key="group.label" class="we-type-group">
        <div class="we-type-group-label">{{ group.label }}</div>
        <div v-for="type in group.types" :key="type" class="we-type-btn" :class="{ active: activeType === type }"
          @click="$emit('select', type)">
          <span class="we-type-icon">
            <i :class="typeMeta[type].icon"></i>
          </span>
          <span>{{ typeMeta[type].name }}</span>
        </div>
      </div>
    </el-card>
  </aside>
</template>

<script>
  import { TYPE_GROUPS, TYPE_META } from '../utils/questionTypes'

  export default {
    name: 'WorkEditorTypePanel',
    props: {
      activeType: {
        type: String,
        default: 'desc'
      }
    },
    data() {
      return {
        typeGroups: TYPE_GROUPS,
        typeMeta: TYPE_META
      }
    }
  }
</script>

<style lang="scss" scoped>
  .we-left-panel {
    position: sticky;
    top: 16px;
    height: fit-content;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .we-type-card {
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: visible;

    ::v-deep .el-card__header {
      padding: 14px 16px;
    }

    ::v-deep .el-card__body {
      padding: 8px 12px 16px;
      overflow: visible;
    }
  }

  .we-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;

    i {
      color: #4f6ef7;
    }
  }

  .we-type-group {
    margin-bottom: 8px;
  }

  .we-type-group-label {
    font-size: 12px;
    font-weight: 600;
    color: #86909c;
    margin: 10px 0 8px;
  }

  .we-type-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1.5px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    color: #4e5969;
    font-size: 13px;
    margin-bottom: 6px;
    transition: all 0.2s;

    >span:last-child {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      background: #eef1fe;
      color: #4f6ef7;
    }

    &.active {
      background: #eef1fe;
      border-color: #4f6ef7;
      color: #4f6ef7;
      font-weight: 600;

      .we-type-icon {
        background: #4f6ef7;
        color: #fff;
      }
    }
  }

  .we-type-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f2f8;
    flex-shrink: 0;
  }
</style>
